import type { ReactNode } from 'react';
import { Icon, type IconName } from '@/components/Icon';
import type { InspectTarget } from '@/types/inspect';

const BADGE: Record<InspectTarget['status'], { className: string; label: string }> = {
  ok: { className: 'badge badge-success', label: 'Connected' },
  unreachable: { className: 'badge badge-error', label: 'Unreachable' },
  unconfigured: { className: 'badge badge-warn', label: 'Not configured' },
};

export function TargetCard({
  target,
  icon,
  children,
}: {
  target: InspectTarget;
  icon: IconName;
  children?: ReactNode;
}) {
  const badge = BADGE[target.status] ?? BADGE.unconfigured;

  return (
    <div className="card mb-24">
      <div className="card-pad row gap-16">
        <div className="tile lg" style={{ background: 'var(--ink-900)', color: 'var(--white)' }}>
          <Icon name={icon} size={18} />
        </div>
        <div className="flex1">
          <div className="row gap-8">
            <div style={{ fontWeight: 600 }}>{target.label}</div>
            <span className={badge.className}>
              <span className="dot" />
              {badge.label}
            </span>
          </div>
          <div className="tiny muted mono">{target.endpoint}</div>
          {target.error ? <div className="tiny muted">{target.error}</div> : null}
        </div>
        {children}
      </div>
    </div>
  );
}
